const interval = 500;

const updateText = () => {
  const elements = document.querySelectorAll(".tee-edit-button__text");
  elements.forEach((element) => {
    element.textContent = "Design anpassen";
  });
};

setInterval(updateText, interval);
